import React from "react";
import "./TitleCardListItem.less";

export const TitleCardListItem = React.memo(({ title, info }) => {
  return (
    <div className="title-card-list-item-container">
      <span className="list-item">
        <b className="eb_fs_16">{`${title}: `}</b>
        {info}
      </span>
    </div>
  );
});
